import { createAsyncThunk } from "@reduxjs/toolkit";
import { deleteFacebookPropertiesData, getFacebookPropertiesData, postFacebookProperties, putFacebookProperties } from "../../../helpers/backend_helper";
import { toast } from "react-toastify";
import { setFacebookId, setIsFacebookProperties, setProperties } from "../reducer";
import { checkMaintenance } from "../../auth/login/helper";
import { toggleFacebookModal } from "../../modals/reducer";
import { replace } from "redux-first-history";
import { fromPairs } from "lodash";
import { updateVersionStatusAfterUpdate } from "../thunk";

export const getFacebookProperties = createAsyncThunk('facebook/getFacebookPropertiesData', async (data, { dispatch, getState }) => {
  const { language } = getState().MenuData;
  try {
    const { currentVersion } = getState().Campaign;
    const res = await getFacebookPropertiesData({ versionId: currentVersion._id });
    if (res.status === 'ok') {
      return res.data;
    } else {
      throw res;
    }
  } catch (error) {
    // console.log(error);
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });
    return null;
  }
});

export const createFacebookProperties = (form) => async (dispatch, getState) => {
  const { language, title } = getState().MenuData;
  try {
    const { client, clientPath, brandPath, marketPath } = getState().MenuData;
    const {
      allLibraries,
      allLibrariesHasMore,
      allLibrariesPage,
      currentCampaign,
      currentVersion,
      versions,
      creatives,
      facebookProperties,
      connectedFeed,
      connectedFeedName,
      dynamicText,
      activeDynamicText,
    } = getState().Campaign;
    const {
      publishTypes,
      selectedPublishType,
      selectedCreativesPublish,
      isBusinessAuthenticated,
      fbCatalogPublishSettings,
      userFacebookId,
      businessList,
      catalogList,
      fbBusinessId,
      catalogId,
    } = getState().Publish;
    const {
      uploadLimits
    } = getState().Upload;
    const facebookPropertiesObj = {
      title: form.title,
      description: form.description,
      availability: form.availability,
      condition: form.condition,
      price: form.price,
      link: form.link,
      image_link: form.image_link,
      brand: form.body,
    };
    if (form.id?.value && form.id.value.trim() !== '') {
      facebookPropertiesObj.id = form.id;
    }
    const res = await postFacebookProperties({
      companyId: client._id,
      clientId: clientPath,
      brandId: brandPath,
      marketId: marketPath,
      campaignId: currentCampaign._id,
      versionId: currentVersion._id,
      creativeIds: selectedCreativesPublish.map(item => item._id),
      properties: facebookPropertiesObj,
      interval: form.interval.value,
      exportType: form.exportType,
      limit: form.limit
    });
    if (res.status === 'ok') {
      const properties = {
        _id: res.data.insertedId,
        properties: facebookPropertiesObj,
        brandId: brandPath,
        interval: form.interval,
        limit: form.limit
      };
      dispatch(setProperties(properties));
      dispatch(setFacebookId(res.data.insertedId));
      dispatch(setIsFacebookProperties(true));
      dispatch(replace(window.location.href, {
        campaigns: allLibraries,
        hasMore: allLibrariesHasMore,
        firstLoad: false,
        campaignPage: allLibrariesPage,
        isLoading: false,
        showLoader: false,
        currentCampaign: currentCampaign,
        versions: versions,
        currentVersion: currentVersion,
        facebookProperties: properties,
        isFacebookPropertiesSet: true,
        facebookStatus: true,
        facebookCreativeIds: selectedCreativesPublish.map(item => item._id),
        connectedFeed: connectedFeed,
        connectedFeedName: connectedFeedName,
        dynamicText: dynamicText,
        activeDynamicText: activeDynamicText,
        fontRes: [],
        previewFonts: [],
        creatives: (creatives || []).map((item) => {
          let returnObj = {};
          let keys = Object.keys(item);
          keys.forEach(key => {
            if (key !== 'preview') {
              returnObj[key] = item[key];
            }
          });
          return returnObj;
        }),
        uploadLimits: uploadLimits,
        title: title,
        // Publish
        whereToPublish: true,
        publishList: publishTypes,
        publishType: selectedPublishType,
        facebookId: res.data.insertedId,
        selectedCreativesPublish: selectedCreativesPublish,
        isBusinessAuthenticated: isBusinessAuthenticated,
        fbCatalogPublishSettings: fbCatalogPublishSettings,
        userFacebookId: userFacebookId,
        businessList: businessList,
        catalogList: catalogList,
        fbBusinessId: fbBusinessId,
        catalogId: catalogId
      }));
      toast.success(language[res?.code], { autoClose: 3000 });
      return true;
    } else {
      throw res;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });
    return false;
  }
};

export const updateFacebookProperties = (form) => async (dispatch, getState) => {
  const { language, brandPath, title } = getState().MenuData;
  try {
    const {
      allLibraries,
      allLibrariesHasMore,
      allLibrariesPage,
      currentCampaign,
      currentVersion,
      versions,
      creatives,
      facebookProperties,
      isFacebookPropertiesSet,
      connectedFeed,
      connectedFeedName,
      dynamicText,
      activeDynamicText,
      facebookId,
      facebookCreativeIds
    } = getState().Campaign;
    const {
      publishTypes,
      selectedPublishType,
      selectedCreativesPublish,
      isBusinessAuthenticated,
      fbCatalogPublishSettings,
      catalogList,
      businessList,
      catalogId,
      fbBusinessId,
      userFacebookId
    } = getState().Publish;
    const {
      uploadLimits
    } = getState().Upload;
    const facebookPropertiesObj = {
      title: form.title,
      description: form.description,
      availability: form.availability,
      condition: form.condition,
      price: form.price,
      link: form.link,
      image_link: form.image_link,
      brand: form.body,
    }
    if (form.id?.value && form.id.value.trim() !== '') {
      facebookPropertiesObj.id = form.id;
    }
    const res = await putFacebookProperties({
      id: facebookId,
      creativeIds: selectedCreativesPublish.map(item => item._id),
      properties: facebookPropertiesObj,
      interval: form.interval.value,
      limit: form.limit
    });
    if (res.status === 'ok') {
      toast.success(language[res.code], { autoClose: 3000 })
      const properties = {
        _id: facebookId, 
        properties: facebookPropertiesObj,
        brandId: brandPath,
        interval: form.interval,
        limit: form.limit
      }
      dispatch(setProperties(properties));
      dispatch(replace(window.location.href, {
        campaigns: allLibraries,
        hasMore: allLibrariesHasMore,
        firstLoad: false,
        campaignPage: allLibrariesPage,
        isLoading: false,
        showLoader: false,
        currentCampaign: currentCampaign,
        versions: versions,
        currentVersion: currentVersion,
        facebookProperties: properties,
        isFacebookPropertiesSet: true,
        facebookStatus: true,
        facebookCreativeIds: selectedCreativesPublish.map(item => item._id),
        connectedFeed: connectedFeed,
        connectedFeedName: connectedFeedName,
        dynamicText: dynamicText,
        activeDynamicText: activeDynamicText,
        fontRes: [],
        previewFonts: [],
        creatives: (creatives || []).map((item) => {
          let returnObj = {};
          let keys = Object.keys(item);
          keys.forEach(key => {
            if (key !== 'preview') {
              returnObj[key] = item[key];
            }
          });
          return returnObj;
        }),
        uploadLimits: uploadLimits,
        title: title,
        // Publish
        whereToPublish: true,
        publishList: publishTypes,
        publishType: selectedPublishType,
        facebookId: facebookId,
        selectedCreativesPublish: selectedCreativesPublish,
        isBusinessAuthenticated: isBusinessAuthenticated,
        fbCatalogPublishSettings: fbCatalogPublishSettings,
        userFacebookId: userFacebookId,
        catalogList: catalogList,
        businessList: businessList,
        catalogId: catalogId,
        fbBusinessId: fbBusinessId
      }))
      return true;
    } else {
      throw res;
    }
  } catch (error) {
    // console.log('error', error);
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });
    return false;
  }
};

export const deleteFacebookProperties = () => async (dispatch, getState) => {
  const {language, title} = getState().MenuData;
  try {
    const { 
      facebookId, 
      isFacebookPropertiesSet,
      facebookCreativeIds,
      currentCampaign,
      versions,
      currentVersion,
      connectedFeed,
      connectedFeedName,
      dynamicText,
      activeDynamicText,
      filteredFontList,
      creatives,
    } = getState().Campaign;
    const uploadLimits = getState().Upload.uploadLimits;
    const res = await deleteFacebookPropertiesData({
      id: facebookId
    });
    const contentId = getState().Campaign.id;
    const facebookProperties = {
      _id: facebookId,
      properties: {
        title: getState().Campaign.title,
        description: getState().Campaign.description,
        availability: getState().Campaign.availability,
        condition: getState().Campaign.condition,
        price: getState().Campaign.price,
        link: getState().Campaign.link,
        image_link: getState().Campaign.image_link,
      },
      brand: getState().Campaign.brand,
      interval: getState().Campaign.interval,
      exportType: 'image',
      limit: getState().Campaign.limit
    };
    if (contentId?.value && contentId.value.trim() !== '') {
      facebookProperties.properties.id = contentId;
    }
    if (res.status === 'ok') {
      // Updates
      const updateRes = await dispatch(updateVersionStatusAfterUpdate(0));
      dispatch(replace(window.location.href, {
        currentCampaign: currentCampaign,
        versions: updateRes.updatedVersions,
        currentVersion: updateRes.updatedVersion,
        facebookProperties: facebookProperties,
        isFacebookPropertiesSet: isFacebookPropertiesSet,
        facebookStatus: false,
        facebookCreativeIds: facebookCreativeIds,
        connectedFeed: connectedFeed,
        connectedFeedName: connectedFeedName,
        dynamicText: dynamicText,
        activeDynamicText: activeDynamicText,
        fontRes: filteredFontList,
        creatives:  (creatives || []).map((item) => {
          let returnObj = {};
          let keys = Object.keys(item);
          keys.forEach(key => {
            if (key !== 'preview') {
              returnObj[key] = item[key];
            }
          });
          return returnObj;
        }),
        uploadLimits: uploadLimits,
        title: title
      }));
      setTimeout(() => {
        toast.success("Successfully unpublished.", {autoClose: 3000});
      }, 1);
    } else {
      throw res;
    }
  } catch (error) {
    setTimeout(() => {
      toast.error("Something went wrong while unpublishing.", {autoClose: 3000});
    }, 1);
  }
}